import { getContactError } from "../../utils/utils";

export const addressValidation = async (params) => {
  const { addressResponse, storeContact, customErrors, disable_smarty_validation } = params;
  
  let validation = {
    isValid: false,
    addressBarcode: "",
    error: {
      message1: "",
      message2: ""
    }
  }
  
  if (!addressResponse || addressResponse.error) {
    validation.isValid = false;
    validation.error.message1 = customErrors.addressError;
    validation.error.message2 = getContactError(storeContact);
    return validation;
  }

  const result = addressResponse;

  if (disable_smarty_validation) {
      validation.addressBarcode = "";
      validation.isValid = true;
  } else {
      if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
              const data = result[i];
              if (data) {
                  validation.addressBarcode = data.delivery_point_barcode;
                  validation.isValid = true;
              } else {
                  validation.isValid = false;
                  validation.error.message1 = customErrors.addressError;
                  validation.error.message2 = getContactError(storeContact);
              }
          }
      }
  }
  return validation;
};
